<div class="word-search-board" [ngClass]="{'bottom-word-list': bottomWordList, 'show-solution': showSolution, 'initialized': initialized}" id="puzzle-screenshot">
  <div class="word-search-board-grid-wrapper">
    <div class="word-search-board-grid" id="word-search-grid" #board [style.height.px]="heightPX * scaleValue" [style.width.px]="widthPX * scaleValue">
      <div class="word-search-grid-inner" [style.transform]="'scale('+scaleValue+')'" [style.height.px]="heightPX" [style.width.px]="widthPX">
        <div class="word-search-board-canvas" [style.height.px]="heightPX" [style.width.px]="widthPX">
          <canvas #backgroundCanvas width="{{widthPX}}" height="{{heightPX}}"></canvas>
        </div>
        <div class="word-search-board-select-canvas" [style.height.px]="heightPX" [style.width.px]="widthPX">
          <canvas #selectCanvas width="{{widthPX}}" height="{{heightPX}}"></canvas>
        </div>
        <div class="word-search-board-row" *ngFor="let row of grid; let rowIndex = index" [style.width.px]="widthPX">
          <div class="word-search-board-cell" *ngFor="let cell of row; let columnIndex = index">
            <div class="word-search-cell-inner" *ngIf="cell.length"
                 [ngClass]="{'selected': selectedFields[rowIndex][columnIndex], 'solution': hasSolutionWord && solutionFields[rowIndex][columnIndex] !== -1}"
                 (mousedown)="cellMouseDown($event, columnIndex, rowIndex)"
                 (touchstart)="cellTouchDown($event, columnIndex, rowIndex)">{{cell}}</div>
            <div class="word-search-cell-empty" *ngIf="!cell.length"></div>
            <div class="word-search-solution" *ngIf="hasSolutionWord && solutionFields[rowIndex][columnIndex] !== -1">
              <div class="word-search-solution-index">{{solutionFields[rowIndex][columnIndex] + 1}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="word-search-board-list puzzle-elevation-z3"
       [style.width] ="bottomWordList ? '100%' : verticalWordListWidth"
       [style.height]="bottomWordList ? horizontalWordListHeight : '100%'">
    <lib-app-word-search-puzzle-word-list
      [style.fontSize.px] = fontSize
      [style.lineHeight.px] = fontSize
      [wordList]="wordList"
      [foundWords]="foundWords"
      [horizontal]="bottomWordList"
      [maxVerticalHeight]="heightPX * scaleValue"
      [maxHorizontalWidth]="widthPX * scaleValue">
    </lib-app-word-search-puzzle-word-list>
  </div>
</div>
